export default __webpack_public_path__ + "static/media/icons-arrow-right.dc9034fc.svg";